module.exports = __webpack_public_path__ + "img/sytz.4dd2ac25.png";